import React from "react";
import { useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import { cart } from '../reducers/cart';
import { useNavigate } from "react-router-dom";
import { resolveImageUrl } from '../utils/imageUrl';

const Cart = () => {
  let navigate = useNavigate();
  const cartItems = useSelector(cart);

  let total = 0;
  let totalCount = 0;
  return (
    <div className="container">
      <div class="cart-container">
      <h2>Shopping Cart</h2>
        <div class="cart-item-container">
        <div class="price-label">PRICE</div>
        {cartItems.map(item => {
          total += (item.item.sizes[item.sizeIdx].price * item.quantity);
          totalCount += item.quantity;
          console.log("ITEM IN CART", item.item);
          return (
            <div class="cart-item">
              <div class="image">
                <img src={resolveImageUrl(item.item.frontModelImage)} width={'150'} alt=''></img>
                
                </div>
              <div class="content">
                <div class="title">{item.item.title}</div>
                <div class="color">Color: {item.item.colorName}</div>
                <div class="size-name">Size: {item.item.sizes[item.sizeIdx].sizeName}</div>
                <div class="quantity">Quantity: {item.quantity}</div>
              </div>
              <div class="price">{(item.item.sizes[item.sizeIdx].price * item.quantity).toLocaleString(undefined, { style: "currency",
  currency: "USD",})}</div>
            </div>
          );})
        }
        <div class="total">Total ({totalCount} items): <strong>{total.toLocaleString(undefined, { style: "currency",
  currency: "USD",})}</strong></div>
        </div>         
      <Button variant="warning" onClick={() => navigate('/checkout')}>Checkout</Button>
      <Button variant="warning" onClick={() => navigate('/processcc')}>Credit Card Checkout</Button>
      </div>
    </div>
  );
};
export default Cart;